import { P } from '@angular/cdk/keycodes';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PartnerPro } from 'src/app/shared/models/partner-pro';
import { ImportService } from 'src/app/shared/services/import.service';
import { PartnerService } from 'src/app/shared/services/partner.service';

@Component({
  selector: 'app-pro-archive-content',
  templateUrl: './pro-archive-content.component.html',
  styleUrls: ['./pro-archive-content.component.scss']
})
export class ProArchiveContentComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  dataSource: MatTableDataSource<any>;

  @ViewChild('scrollContainer') scrollContainerRef!: ElementRef;

  loading: boolean = false;

  columns = [
    '#',
    'YEAR',
    'QUARTER',
    'DISTRIBUTION YEAR',
    'DISTRIBUTION QUARTER',
    'STATEMENT RECIPIENT ID',
    'STATEMENT RECIPIENT NAME',
    'PARTY ID',
    'PARTY NAME',
    'LEGAL EARNER PARTY ID',
    'LEGAL EARNER PARTY NAME',
    'PERFORMANCE SOURCE',
    'MUSIC USER GENRE',
    'MUSIC USER',
    'NETWORK SERVICE',
    'PERFORMANCE START DATE',
    'PERFORMANCE END DATE',
    'SURVEY TYPE',
    'DAY PART CODE',
    'SERIES OR FILM/ATTRACTION',
    'PROGRAM/EPISODE NAME',
    'WORK ID',
    'WORK TITLE',
    'CA%',
    'CLASSIFICATION CODE',
    'NUMBER OF PLAYS',
    'PERFORMANCE TYPE',
    'DURATION',
    'PERFORMING ARTIST',
    'COMPOSER NAME',
    'EE SHARE',
    'CREDITS',
    'DOLLARS',
    'PREMIUM CREDITS',
    'PREMIUM ROYALTY',
    'ADJUSTMENT INDICATOR',
    'ADJUSTMENT REASON CODE',
    'ORIGINAL DISTRIBUTION DATE',
    'ROLE TYPE',
    'TYPE OF RIGHT',
    'TERRITORY',
    'LICENSOR',
    'PROGRAM CODE',
    'PERFORMANCE QUARTER',
    'COUNTRY NAME',
    'FILE TYPE',
    'LICENSOR CODE',
    'REVENUE CLASS CODE',
    'REVENUE CLASS DESCRIPTION',
    'ADJUSTMENT DISTRIBUTION DATE',
    'CURRENT ACTIVITY AMOUNT',
    'HIT SONG BONUS',
    'STANDARDS BONUS',
    'FOREIGN SOCIETY ADJUSTMENT',
    'PERFORMANCE DATE',
    'W OR P',
    'SHOW NAME',
    'PAYMENT TYPE',
    'CHART',
    'PAY NUMBER',
    'SYND',
    'STRIP',
    'PERFORMANCE',
    'OCCUR',
    'SOCIETY ABBRV',
    'SOCIETY COUNTRY'
  ];


  displayedColumns = [
    'position',
    'year',
    'quarter',
    'distributionYear',
    'distributionQuarter',
    'statementRecipientId',
    'statementRecipientName',
    'partyId',
    'partyName',
    'legalEarnerPartyId',
    'legalEarnerPartyName',
    'performanceSource',
    'musicUserGenre',
    'musicUser',
    'networkService',
    'performanceStartDate',
    'performanceEndDate',
    'serveyType',
    'dayPartCode',
    'show',
    'episodeName',
    'workId',
    'workTitle',
    'allocationPercentage',
    'classificationCode',
    'numberOfPlays',
    'performanceType',
    'duration',
    'performingArtist',
    'composerName',
    'eeShare',
    'credits',
    'royalty',
    'premiumCredits',
    'premiumRoyalty',
    'adjustmentIndicator',
    'adjustmentReasonCode',
    'originalDistributionDate',
    'roleType',
    'typeOfRight',
    'terriotry',
    'licensor',
    'programCode',
    'performanceQuarter',
    'countryName',
    'fileType',
    'licensorCode',
    'revenueClassCode',
    'revenueClassDescription',
    'adjustentDistributionDate',
    'currentActivityAmt',
    'hitSongBonus',
    'standardsBonus',
    'foreignSocietyAdjustment',
    'perfDate',
    'wOrP',
    'showName',
    'paymentType',
    'chart',
    'payNumber',
    'synd',
    'strip',
    'performance',
    'occur',
    'socidetyAbbrv',
    'societyCountry'
  ];

  allPartnerPros: PartnerPro[] = [];
  approvedPartnerPros: PartnerPro[] = [];

  proType: string;
  proYear: number;
  proQuarter: string;

  tablePage: number = 1;
  tablePageSize: number = 10;

  tableData: any;

  sortedBy: string;
  reverseSort = false;

  constructor(private importService: ImportService, private partnerService: PartnerService) { }

  ngOnInit() {

    //track type, year and quarter - gets partner pros accordingly

    this.partnerService.proType$.subscribe((resType) => {
      this.proType = resType;

      this.partnerService.proYear$.subscribe((resYear) => {
        this.proYear = resYear;

        this.partnerService.proQuarter$.subscribe((resQuarter) => {
          this.proQuarter = resQuarter;

          //set table to page 1;
          this.partnerService.setTablePage(1);

          this.partnerService.setTablePageSize(10);

          //track page
          this.partnerService.tablePage$.subscribe((x) => {
            this.tablePage = x;

            //track page size
            this.partnerService.tablePageSize$.subscribe((x) => {
              this.tablePageSize = x;

            })

            //page changed - update table
            //timeout give both page and pageSize time to update
            setTimeout(() => {
              this.getPros();

            }, 500);
          });
        });
      });
    });
  }

  getPros(sortBy?: string) {
    //check if reversing sort order
    if(this.sortedBy == sortBy){
      this.reverseSort = !this.reverseSort;
    }

    this.sortedBy = sortBy;

    if (this.proType && this.proYear && this.proQuarter) {
      this.loading = true;

      //reset
      this.allPartnerPros = [];

      this.partnerService.getPartnerPros(this.proType, this.proYear, this.proQuarter, this.tablePage, this.tablePageSize, sortBy, this.reverseSort).subscribe(resPartnerPros => {
        
        this.tableData = resPartnerPros;

        this.allPartnerPros = resPartnerPros.data.map(item => PartnerPro.mapProperties(item))

        this.approvedPartnerPros = this.allPartnerPros.filter(x => x.isApproved != false)

        //this.dataSource = new MatTableDataSource(this.approvedPartnerPros);

        this.loading = false;

      })
    }
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  onScroll(event: Event) {
    // Pass the scroll event to the custom scrollbar component if needed
  }

  sortTable(col: string) {
    let isReversed = true;

    this.allPartnerPros.sort((a, b) => {
      let valueA, valueB;

      switch (col) {
        case 'YEAR':
          valueA = a.year;
          valueB = b.year;
          break;
        case 'QUARTER':
          valueA = a.quarter;
          valueB = b.quarter;
          break;
        case 'DISTRIBUTION YEAR':
          valueA = a.distributionYear;
          valueB = b.distributionYear;
          break;
        case 'DISTRIBUTION QUARTER':
          valueA = a.distributionQuarter;
          valueB = b.distributionQuarter;
          break;
        case 'STATEMENT RECIPIENT ID':
          valueA = a.statementRecipientId;
          valueB = b.statementRecipientId;
          break;
        case 'STATEMENT RECIPIENT NAME':
          valueA = a.statementRecipientName;
          valueB = b.statementRecipientName;
          break;
        case 'PARTY ID':
          valueA = a.partyId;
          valueB = b.partyId;
          break;
        case 'PARTY NAME':
          valueA = a.partyName;
          valueB = b.partyName;
          break;
        case 'LEGAL EARNER PARTY ID':
          valueA = a.legalEarnerPartyId;
          valueB = b.legalEarnerPartyId;
          break;
        case 'LEGAL EARNER PARTY NAME':
          valueA = a.legalEarnerPartyName;
          valueB = b.legalEarnerPartyName;
          break;
        case 'PERFORMANCE SOURCE':
          valueA = a.performanceSource;
          valueB = b.performanceSource;
          break;
        case 'MUSIC USER GENRE':
          valueA = a.musicUserGenre;
          valueB = b.musicUserGenre;
          break;
        case 'MUSIC USER':
          valueA = a.musicUser;
          valueB = b.musicUser;
          break;
        case 'NETWORK SERVICE':
          valueA = a.networkService;
          valueB = b.networkService;
          break;
        case 'PERFORMANCE START DATE':
          valueA = new Date(a.performanceStartDate);
          valueB = new Date(b.performanceStartDate);
          break;
        case 'PERFORMANCE END DATE':
          valueA = new Date(a.performanceEndDate);
          valueB = new Date(b.performanceEndDate);
          break;
        case 'SURVEY TYPE':
          valueA = a.surveyType;
          valueB = b.surveyType;
          break;
        case 'DAY PART CODE':
          valueA = a.dayPartCode;
          valueB = b.dayPartCode;
          break;
        case 'SHOW':
          valueA = a.show?.name;
          valueB = b.show?.name;
          break;
        case 'EPISODE NAME':
          valueA = a.episodeName;
          valueB = b.episodeName;
          break;
        case 'WORK ID':
          valueA = a.workId;
          valueB = b.workId;
          break;
        case 'WORK TITLE':
          valueA = a.workTitle;
          valueB = b.workTitle;
          break;
        case 'ALLOCATION PERCENTAGE':
          valueA = a.allocationPercentage;
          valueB = b.allocationPercentage;
          break;
        case 'CLASSIFICATION CODE':
          valueA = a.classificationCode;
          valueB = b.classificationCode;
          break;
        case 'NUMBER OF PLAYS':
          valueA = a.numberOfPlays;
          valueB = b.numberOfPlays;
          break;
        case 'PERFORMANCE TYPE':
          valueA = a.performanceType;
          valueB = b.performanceType;
          break;
        case 'DURATION':
          valueA = a.duration;
          valueB = b.duration;
          break;
        case 'PERFORMING ARTIST':
          valueA = a.performingArtist;
          valueB = b.performingArtist;
          break;
        case 'COMPOSER NAME':
          valueA = a.composerName;
          valueB = b.composerName;
          break;
        case 'EE SHARE':
          valueA = a.eeShare;
          valueB = b.eeShare;
          break;
        case 'CREDITS':
          valueA = a.credits;
          valueB = b.credits;
          break;
        case 'ROYALTY':
          valueA = a.royalty;
          valueB = b.royalty;
          break;
        case 'PREMIUM CREDITS':
          valueA = a.premiumCredits;
          valueB = b.premiumCredits;
          break;
        case 'PREMIUM ROYALTY':
          valueA = a.premiumRoyalty;
          valueB = b.premiumRoyalty;
          break;
        case 'ADJUSTMENT INDICATOR':
          valueA = a.adjustmentIndicator;
          valueB = b.adjustmentIndicator;
          break;
        case 'ADJUSTMENT REASON CODE':
          valueA = a.adjustmentReasonCode;
          valueB = b.adjustmentReasonCode;
          break;
        case 'ORIGINAL DISTRIBUTION DATE':
          valueA = new Date(a.originalDistributionDate);
          valueB = new Date(b.originalDistributionDate);
          break;
        case 'ROLE TYPE':
          valueA = a.roleType;
          valueB = b.roleType;
          break;
        case 'TYPE OF RIGHT':
          valueA = a.typeOfRight;
          valueB = b.typeOfRight;
          break;
        case 'TERRITORY':
          valueA = a.territory;
          valueB = b.territory;
          break;
        case 'LICENSOR':
          valueA = a.licensor;
          valueB = b.licensor;
          break;
        case 'PROGRAM CODE':
          valueA = a.programCode;
          valueB = b.programCode;
          break;
        case 'PERFORMANCE QUARTER':
          valueA = a.performanceQuarter;
          valueB = b.performanceQuarter;
          break;
        case 'COUNTRY NAME':
          valueA = a.countryName;
          valueB = b.countryName;
          break;
        case 'FILE TYPE':
          valueA = a.fileType;
          valueB = b.fileType;
          break;
        case 'LICENSOR CODE':
          valueA = a.licensorCode;
          valueB = b.licensorCode;
          break;
        case 'REVENUE CLASS CODE':
          valueA = a.revenueClassCode;
          valueB = b.revenueClassCode;
          break;
        case 'REVENUE CLASS DESCRIPTION':
          valueA = a.revenueClassDescription;
          valueB = b.revenueClassDescription;
          break;
        case 'ADJUSTMENT DISTRIBUTION DATE':
          valueA = new Date(a.adjustmentDistributionDate);
          valueB = new Date(b.adjustmentDistributionDate);
          break;
        case 'CURRENT ACTIVITY AMOUNT':
          valueA = a.currentActivityAmt;
          valueB = b.currentActivityAmt;
          break;
        case 'HIT SONG BONUS':
          valueA = a.hitSongBonus;
          valueB = b.hitSongBonus;
          break;
        case 'STANDARDS BONUS':
          valueA = a.standardsBonus;
          valueB = b.standardsBonus;
          break;
        case 'FOREIGN SOCIETY ADJUSTMENT':
          valueA = a.foreignSocietyAdjustment;
          valueB = b.foreignSocietyAdjustment;
          break;
        case 'PERFORMANCE DATE':
          valueA = new Date(a.perfDate);
          valueB = new Date(b.perfDate);
          break;
        case 'W OR P':
          valueA = a.wOrP;
          valueB = b.wOrP;
          break;
        case 'SHOW NAME':
          valueA = a.showName;
          valueB = b.showName;
          break;
        case 'PAYMENT TYPE':
          valueA = a.paymentType;
          valueB = b.paymentType;
          break;
        case 'CHART':
          valueA = a.chart;
          valueB = b.chart;
          break;
        case 'PAY NUMBER':
          valueA = a.payNumber;
          valueB = b.payNumber;
          break;
        case 'SYND':
          valueA = a.synd;
          valueB = b.synd;
          break;
        case 'STRIP':
          valueA = a.strip;
          valueB = b.strip;
          break;
        case 'PERFORMANCE':
          valueA = a.performance;
          valueB = b.performance;
          break;
        case 'OCCUR':
          valueA = a.occur;
          valueB = b.occur;
          break;
        case 'SOCIETY ABBRV':
          valueA = a.societyAbbrv;
          valueB = b.societyAbbrv;
          break;
        case 'SOCIETY COUNTRY':
          valueA = a.societyCountry;
          valueB = b.societyCountry;
          break;
        default:
          return 0; // If the column name doesn't match, don't change the order
      }

      // Check if the current sorting is ascending
      if (valueA < valueB) isReversed = false;
      if (valueA > valueB) isReversed = true;

      if (valueA < valueB) return -1;
      if (valueA > valueB) return 1;
      return 0;
    });

    // If already sorted in ascending order, reverse the array
    if (isReversed) {
      this.allPartnerPros.reverse();
    }
  }

}
